export default __webpack_public_path__ + "static/pattern-gray-304fb616864b7ea26ef4b30eeff08da3.png";